import ScoreCircle from './ScoreCircle';
import type { BrandingAnalyzeResponse } from '../../api/brandingApi';

interface Props {
  result: BrandingAnalyzeResponse;
}

function gradeLabel(score: number): string {
  if (score >= 90) return 'Excellent';
  if (score >= 75) return 'Good';
  if (score >= 55) return 'Needs improvement';
  return 'Needs attention';
}

export default function ScanResultSummary({ result }: Props) {
  const checks = result.checks ?? [];
  const passed = checks.filter((check) => check.status === 'PASS').length;
  const warnings = checks.filter((check) => check.status === 'WARNING').length;
  const failed = checks.filter((check) => check.status === 'FAIL').length;

  return (
    <div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(310px, 1.35fr) repeat(3, minmax(110px, .55fr))',
          gap: '0',
          alignItems: 'stretch',
        }}
        className="asneris-summary-grid"
      >
        <style>{`
          @media (max-width: 820px) {
            .asneris-summary-grid { grid-template-columns: 1fr !important; }
            .asneris-summary-stat { border-left: 0 !important; border-top: 1px solid var(--asneris-border); }
          }
        `}</style>

        <div style={{ display: 'flex', gap: '20px', alignItems: 'center', paddingRight: '20px' }}>
          <ScoreCircle score={result.overallScore} size={124} />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: '22px', lineHeight: 1.15, fontWeight: 800, color: '#15803d' }}>
              Grade {result.overallGrade}
            </div>
            <div style={{ marginTop: '6px', fontSize: '16px', fontWeight: 700, color: 'var(--asneris-navy)' }}>
              {gradeLabel(result.overallScore)}
            </div>
            <p style={{ margin: '8px 0 0', fontSize: '13px', lineHeight: 1.55, color: 'var(--asneris-text)' }}>
              {result.summary}
            </p>
            <div style={{ marginTop: '8px', fontSize: '12px', color: 'var(--asneris-muted)' }}>
              {result.domain}
            </div>
          </div>
        </div>

        {[
          { value: passed, label: 'Passed checks', color: '#15803d', icon: '✓' },
          { value: warnings, label: 'Warnings', color: '#d97706', icon: '!' },
          { value: failed, label: 'Issues', color: '#dc2626', icon: '×' },
        ].map((item) => (
          <div
            key={item.label}
            className="asneris-summary-stat"
            style={{
              borderLeft: '1px solid var(--asneris-border)',
              padding: '12px 18px',
              display: 'grid',
              placeItems: 'center',
              textAlign: 'center',
            }}
          >
            <span
              aria-hidden="true"
              style={{
                width: 30,
                height: 30,
                borderRadius: '50%',
                border: `2px solid ${item.color}`,
                color: item.color,
                display: 'grid',
                placeItems: 'center',
                fontWeight: 800,
                marginBottom: '8px',
              }}
            >
              {item.icon}
            </span>
            <strong style={{ fontSize: '22px', color: 'var(--asneris-navy)' }}>{item.value}</strong>
            <span style={{ marginTop: '2px', fontSize: '11px', color: 'var(--asneris-muted)' }}>
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
